<template>
    <Variants
        ref="inner"
        :embeddedInDrawer="true"
        v-bind="$props"
        @onCenterChart="handleOnCenterChart"
        @onRequestModelInfo="handleOnRequestModelInfo"
        @onLoadChart="handleOnLoadChart"
        @onColorLoops="handleOnColorLoops"
        @onReset="handleOnReset"
        @variantsLoading="handleVariantsLoading"
        @onChangedVariant="handleOnChangedVariant"
        @onChangedVariantTab="handleOnChangedVariantTab"
        @onOpenRenameModal="handleOnOpenRenameModal"
    />
</template>

<script>
import VueTypes from 'vue-types'
import Variants from '../Variants/Variants.vue'

export default {
    name: 'ProcessVariantsDrawerPanel',
    components: { Variants },
    inheritAttrs: false,
    props: {
        modelValue: VueTypes.object,
        processId: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        info: VueTypes.object,
        filteredInfo: VueTypes.object,
        percentageMode: VueTypes.string,
        disableElements: VueTypes.bool,
        showLoopsSection: VueTypes.bool,
    },
    methods: {
        initialize() {
            this.initializeVariants()
        },
        initializeVariants() {
            this.$refs.inner?.initializeVariants?.()
        },
        renameVariant(payload) {
            this.$refs.inner?.renameVariant?.(payload)
        },

        handleOnCenterChart(payload) {
            this.$emit('on-center-chart', payload)
        },
        handleOnRequestModelInfo(payload) {
            this.$emit('on-request-model-info', payload)
        },
        handleOnLoadChart(payload) {
            this.$emit('on-load-chart', payload)

            // Variants emits onRequestModelInfo before the model request resolves.
            // Emitting again after we have the model payload prevents missing displayedInfo
            // when the graph view isn't mounted yet.
            if (payload && (payload.variants || payload.variantId || payload.loopId || payload.loopId === 0)) {
                const requestPayload = {
                    variants: payload.variants,
                    variantId: payload.variantId,
                    loopId: payload.loopId,
                }
                this.$emit('on-request-model-info', requestPayload)
            }
        },
        handleOnColorLoops(payload) {
            this.$emit('on-color-loops', payload)
        },
        handleOnReset(payload) {
            this.$emit('on-reset', payload)
        },
        handleVariantsLoading(payload) {
            this.$emit('variants-loading', payload)
        },
        handleOnChangedVariant(payload) {
            this.$emit('on-changed-variant', payload)
        },
        handleOnChangedVariantTab(payload) {
            this.$emit('on-changed-variant-tab', payload)
        },
        handleOnOpenRenameModal(payload) {
            this.$emit('on-open-rename-modal', payload)
        },
    },
}
</script>
